<form class="flex flex-col gap-5 px-0 pt-5" [formGroup]="emailForm">

    <div>
      <app-input-label
        labelFor="email"
        [isRequired]="true"
        labelClass="label--bottom-margin"
        >Email</app-input-label
      >
      <app-input
        placeholder="Enter email"
        inputClass="input--padding"
        formControlName="email"
      ></app-input>
    </div>
    <div *ngIf="showBvnField">
      <app-input-label
        labelFor="email"
        [isRequired]="true"
        labelClass="label--bottom-margin"
        >BVN</app-input-label
      >
      <app-input
        placeholder="Enter BVN"
        inputClass="input--padding"
        formControlName="bvn"
      ></app-input>
    </div>
    <button
      mango-button
      (click)="submitForm()"
      [disabled]="!emailForm.valid || isValidating"
      class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end"
    >
      {{ isValidating ? 'Processing...' : 'Continue' }}
    </button>
</form>
